$(document).on('turbolinks:load', function() {
  const prices_edit_sel = '.price-calendar-create';
  const prices_show_sel = '.price-calendar-show';
  const optional_prices_edit_sel = '.optional_price-new';
  const optional_prices_show_sel = '.optional_price-show';
  const select_price_sel = '#select_price_facility';

  // 価格表のどの画面で動作しているか確認
  // 他のpacks/xxxx.jsから使用するためにブラウザグローバル変数windowに保存
  window.g_prices = {
    sel: {
      prices_edit: prices_edit_sel,
      prices_show: prices_show_sel,
      optional_prices_edit: optional_prices_edit_sel,
      optional_prices_show: optional_prices_show_sel,
      select_price: select_price_sel,
    },

    // 時間枠価格表 新規作成
    is_prices_edit: $(prices_edit_sel).length > 0,
    // 時間枠価格表 詳細 または 時間枠価格表の選択
    is_prices_show: $(prices_show_sel).length > 0,
    // 時間あたり価格表 新規作成
    is_optional_prices_edit: $(optional_prices_edit_sel).length > 0,
    // 時間あたり価格表 詳細 または 時間あたり価格表の選択
    is_optional_prices_show: $(optional_prices_show_sel).length > 0,
    // 価格表の選択であるか 価格表 詳細であるか
    is_select_price: $(select_price_sel).length > 0,

    // 表示順
    date_types: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
  };
});

require("packs/price_calendar")
require("packs/price_calendar_readonly")
require("packs/optional_price")
